{
  "action": {
    "administrationRecord": "Skriv ut signeringslista",
    "wristband": "Skriv ut patientarmband",
    "print": "Skriv ut",
    "back": "Tillbaka till patientöversikten",
    "recordExtract": "Skriv ut journalutdrag"
  },
  "document": {
    "loading": "Hämtar underlaget för utskrift …",
    "failed": "Underlaget för utskrift kunde inte hämtas.",
    "notFound": "Patienten finns inte i journalen.",
    "retry": "Försök igen",
    "preview": "Förhandsvisning. Det här är vad som kommer ut på papper.",
    "confidentialityReview": "Skyddad identitet. Granska innan du skriver ut och lämnar papperet ifrån dig.",
    "source": "AKUTJOURNAL — AVBROTTSLÄGE",
    "printedAt": "Utskrivet ur Continuum {time}.",
    "printedAtUnknown": "Utskriftstiden kunde inte anges.",
    "verify": "Uppgifterna kan ha ändrats efter utskriften. Kontrollera mot journalen."
  },
  "mar": {
    "heading": "Signeringslista — läkemedel",
    "identification": "{name} — {identifier}",
    "noIdentifier": "ingen identitetsbeteckning",
    "safetyHeading": "Säkerhetsinformation",
    "medicationsHeading": "Ordinationer",
    "noMedications": "Inga aktuella läkemedelsordinationer i journalen.",
    "caption": "Aktuella läkemedelsordinationer med rutor för signering, en rad per ordination.",
    "columnSigning": "Given — datum, tid, signatur",
    "signingHint": "Skriv datum, tid och signatur för varje given dos. Rutorna är avsiktligt tomma: systemet fyller inte i tider.",
    "notInRecord": "Given läkemedel dokumenteras på papper i avbrottsläget och förs inte in i journalen i fas 0.",
    "doseUnprintable": "DOS KAN INTE SKRIVAS UT",
    "doseWarning": "{count, plural, one {En ordination har en dos som inte kan skrivas ut} other {# ordinationer har doser som inte kan skrivas ut}}. Signera inte mot en tom dosruta — läs dosen i journalen."
  },
  "wristband": {
    "heading": "Patientarmband",
    "cutHint": "Klipp längs den streckade linjen.",
    "born": "Född",
    "barcodeUnavailable": "Streckkod kan inte skrivas ut för den här beteckningen. Läs numret ovan.",
    "noIdentifier": "Ingen identitetsbeteckning i journalen. Ett armband utan beteckning går inte att skriva ut — en oidentifierad patient ska ha ett reservnummer.",
    "checkText": "Vid avvikelse mellan streckkod och siffror gäller siffrorna."
  },
  "extract": {
    "heading": "Journalutdrag",
    "scope": "Utdraget visar patientens aktuella uppgifter och samtliga signerade anteckningar, nyast först. Tidigare versioner av rättade uppgifter ingår inte — de finns kvar i journalen.",
    "admitted": "Inskriven",
    "medicationsHeading": "Aktuella läkemedel",
    "medicationsCaption": "Aktuella läkemedelsordinationer, en rad per ordination.",
    "notesHeading": "Signerade anteckningar",
    "notesCount": "{count, plural, one {# signerad anteckning} other {# signerade anteckningar}}",
    "notesCaption": "Signerade anteckningar, nyast först.",
    "noNotes": "Inga signerade anteckningar i journalen.",
    "forensic": "Markerad som rättsmedicinskt relevant"
  }
}
